import type { Apis, SessionService } from '@efdigital/ll-addon-auth';
import type { Cohort } from '@efdigital/ll-addon-data';
import config from '@efdigital/ll-xceed-v2/config/environment';
import Service, { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import { queryCohortsByParticipantGroupIds } from '../data/builders/xceed/cohorts.ts';

const apis: Apis = config['ll-addon-auth-apis'];

export default class ProgramsService extends Service {
  @service declare store: Store;
  @service declare session: SessionService;

  apis = apis;

  #cachedCohorts: { exists: boolean; cohorts: Cohort[] } | null = null;

  async #ensureCachedCohorts() {
    if (this.#cachedCohorts) {
      return this.#cachedCohorts;
    }

    const groupIds =
      this.session.cached.data?.authenticated.idTokenClaims['https://va/g'] ||
      [];
    const queries = queryCohortsByParticipantGroupIds(groupIds);

    const cohorts: Cohort[] = [];

    for (const query of queries) {
      const response = await this.store.request(query);
      cohorts.push(...response.content.data);
    }
    this.#cachedCohorts = { exists: cohorts.length > 0, cohorts };
    return this.#cachedCohorts;
  }

  async cohorts() {
    return (await this.#ensureCachedCohorts()).cohorts;
  }

  async isParticipant() {
    return (await this.#ensureCachedCohorts()).exists;
  }
}
